import React, { useState, useEffect } from 'react';


interface PasswordGateProps {
  children: React.ReactNode;
}

const HARDCODED_PASSWORD = 'dialysis2025'; 

const PasswordGate: React.FC<PasswordGateProps> = ({ children }) => {
  // Initialize authentication state from sessionStorage to avoid flash
  const [isAuthenticated, setIsAuthenticated] = useState(() => {
    return sessionStorage.getItem('authenticated') === 'true';
  });
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    if (password === HARDCODED_PASSWORD) {
      setIsAuthenticated(true);
      sessionStorage.setItem('authenticated', 'true');
      setError('');
    } else {
      setError('Incorrect password');
      setPassword('');
    }
  };

  if (isAuthenticated) {
    return <>{children}</>;
  }

  return (
    <div className="password-gate">
      <div className="password-gate-container">
        <h1>Access Restricted</h1>
        <p style={{textAlign:"left"}}>Please enter the password to continue</p>
        <form onSubmit={handleSubmit}>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Enter password"
            className="password-input"
            autoFocus
          />
          {error && <div className="error-message">{error}</div>}
          <button type="submit" className="submit-button">
            Enter
          </button>
        </form>
      </div>
    </div>
  );
};

export default PasswordGate;